import { useContext } from "react";

import { SupplierContext } from "../context/SupplierContext";

export const useSupplierContext = () => {
  const context = useContext(SupplierContext);

  return context;
};
